import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  Image,
} from "@react-pdf/renderer";
import dayjs, { Dayjs } from "dayjs";
import { Employee, Skill } from "../../api/EmployeesApiClient";
const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: "Helvetica",
  },
  header: {
    flexDirection: "row",
    marginBottom: 20,
  },
  image: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginRight: 20,
  },
  headerText: {
    justifyContent: "center",
  },
  name: {
    fontSize: 24,
    fontWeight: "bold",
  },
  title: {
    fontSize: 18,
    marginBottom: 5,
  },
  contact: {
    fontSize: 12,
    marginBottom: 2,
  },
  columns: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  leftColumn: {
    width: "35%",
    paddingRight: 10,
  },
  rightColumn: {
    width: "60%",
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 5,
    marginTop: 10,
    color: "#003876",
  },
  text: {
    fontSize: 12,
    marginBottom: 5,
  },
  experienceBlock: {
    marginBottom: 10,
  },
  educationContainer: {
    padding: 20,
    marginBottom: 16,
    width: "100%",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    borderRadius: 8,
    backgroundColor: "#fff",
  },
  educationBlock: {
    padding: 16,
    backgroundColor: "#fff",
    borderRadius: 8,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  university: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#2a2a2a",
    marginBottom: 8,
  },
  degree: {
    color: "#4a4a4a",
    fontSize: 14,
    marginBottom: 8,
  },
  location: {
    color: "#6c6c6c",
    fontSize: 14,
    marginBottom: 8,
  },
  dates: {
    color: "#8c8c8c",
    fontSize: 14,
    marginBottom: 8,
  },
  divider: {
    marginVertical: 12,
    borderColor: "#e8e8e8",
    borderBottomWidth: 1,
  },
  achievements: {
    backgroundColor: "#e6f7ff",
    color: "#1890ff",
    padding: 8,
    borderRadius: 4,
    fontWeight: "bold",
    fontSize: 14,
  },
});
function ParseToJson(str: string): any[] {
  try {
    return JSON.parse(str);
  } catch (e) {
    return [];
  }
}
interface EmployeeProps {
  user: Employee;
  skills: Skill[];
}
const CVGenerator: React.FC<EmployeeProps> = ({ user, skills }) => {
  const {
    firstName,
    lastName,
    email,
    jobTitle,
    experience,
    skype,
    phoneNumber,
    aboutMe,
    education,
    photoId,
    hobby,
  } = user;
  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.header}>
          <Image
            src={
              photoId
                ? `https://res.cloudinary.com/dnl3x07wo/image/upload/${photoId}`
                : "https://res.cloudinary.com/dnl3x07wo/image/upload/w_300/z03w7hlsy8hcoic9dlcn"
            }
            style={styles.image}
          />
          <View style={styles.headerText}>
            <Text style={styles.name}>
              {firstName} {lastName}
            </Text>
            <Text style={styles.title}>{jobTitle}</Text>
            <Text style={styles.contact}>{email}</Text>
            <Text style={styles.contact}>{phoneNumber}</Text>
            <Text style={styles.contact}>{skype}</Text>
          </View>
        </View>

        <View style={styles.columns}>
          <View style={styles.leftColumn}>
            <Text style={styles.sectionTitle}>Summary</Text>
            <Text style={styles.text}>{aboutMe}</Text>

            <Text style={styles.sectionTitle}>Relevant Skills</Text>
            {skills.slice(0, 12).map((skill, index) => (
              <Text key={index} style={styles.text}>
                • {skill.title}
              </Text>
            ))}

            {skills.length > 12 && (
              <Text style={styles.text}>...and {skills.length - 12} more</Text>
            )}

            <Text style={styles.sectionTitle}>Hobby</Text>
            <Text>{hobby}</Text>
          </View>

          <View style={styles.rightColumn}>
            {/* <Text style={styles.sectionTitle}>Work Experience</Text>
            <Text style={styles.experienceBlock}>{experience}</Text>
            {JSON.parse(experience).map((exp: { position: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; company: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; duration: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; description: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }, index: React.Key | null | undefined) => (
              <View key={index} style={styles.experienceBlock}>
                <Text style={styles.text}>{exp.position} at {exp.company}</Text>
                <Text style={styles.text}>{exp.duration}</Text>
                <Text style={styles.text}>{exp.description}</Text>
              </View>
            ))} */}

            <Text style={styles.sectionTitle}>Education History</Text>
            {ParseToJson(education).map((edu, index) => (
              <View key={index} style={styles.educationContainer}>
                <View style={styles.educationBlock}>
                  <Text style={styles.university}>{edu.University}</Text>
                  <Text style={styles.degree}>{edu.Degree}</Text>
                  <Text style={styles.location}>
                    {edu.City}, {edu.Country}
                  </Text>
                  <Text style={styles.dates}>
                    {edu.StartDate
                      ? dayjs(edu.StartDate).format("YYYY-MM-DD")
                      : ""}{" "}
                    -
                    {edu.EndDate ? dayjs(edu.EndDate).format("YYYY-MM-DD") : ""}
                  </Text>
                  {edu.achievements && (
                    <>
                      <View style={styles.divider} />
                      <Text style={styles.achievements}>
                        {edu.achievements}
                      </Text>
                    </>
                  )}
                </View>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
};
export default CVGenerator;
